import React, { useState, useEffect } from 'react';
import { Switch } from '../../../../../components/buttons';
import Select from 'react-select';

const options = [
    { value: 'pending', label: 'Pending' },
    { value: 'placed', label: 'Placed' },
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'confirmed', label: 'Confirmed' },
    { value: 'allocated', label: 'Allocated' },
    { value: 'picking_up', label: 'Picking up' },
    { value: 'picked', label: 'Picked' },
    { value: 'dropping_off', label: 'Dropping off' },
    { value: 'delivered', label: 'Delivered' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'rejected', label: 'Rejected' },
    { value: 'return_in_transit', label: 'Return In Transit' },
    { value: 'returned', label: 'Returned' },
    { value: 'disposed', label: 'Disposed' },
    { value: 'on_hold', label: 'On Hold' },
    { value: 'courier_not_found', label: 'Courier not found' }
]

export default function (props) {
    const [ view, setView ] = useState(false);
    const [ selectedStatus, setSelectedStatus ] = useState([]);

    useEffect(() => {
        let selected = [];
        for(let i = 0; i < props.value.length; i ++) {
            for (let j = 0; j < options.length; j ++) {
                if (props.value[i] === options[j].value) {
                    selected.push({
                        label:options[j].label,
                        value:options[j].value
                    })
                    continue;
                }
            }
        }
        setSelectedStatus(selected);
    },[props.value]);

    const onChangeStatus = (e) => {
        if (e) {
            const selected = e.reduce((r,i) => {
                r.push(i.value);
                return r
            },[])
            setSelectedStatus(selected);
            props.onChange(selected)
            return;
        };
        setSelectedStatus([]);
        props.onChange([]);
        return;
    }

    return (
        <div className="border-bottom">
            <div className={`${view ? null : "filter-view"}`}>
                <div className="py-3 container">
                    <div 
                        className="pointer row justify-content-between px-4" 
                        onClick={props.open ? props.onClickOpen : props.onClickClose}
                    >
                        Status pengiriman
                    </div>
                </div>
            </div>
            {
                props.open ? 
                    <div className="bg-lighter p-4">
                        <Select
                            isMulti
                            value={selectedStatus}
                            onChange={e => onChangeStatus(e)}
                            options={options}
                            placeholder="Masukkan status pengiriman"
                        />
                    </div>
                    : 
                    null
            }
        </div>
    )
};